import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=276299c9&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=276299c9&prod&scoped=true&lang=css"
import style1 from "./Welcome.vue?vue&type=style&index=1&id=276299c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276299c9",
  null
  
)

export default component.exports